export function scrollToString(text, cssSelector) {
  if (!text || typeof text !== "string") return false;
  if (!cssSelector || typeof cssSelector !== "string") return false;

  const container = document.querySelector(cssSelector);
  if (!container) return false;

  const walker = document.createTreeWalker(container, NodeFilter.SHOW_TEXT, {
    acceptNode(node) {
      return node.nodeValue.includes(text) ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_REJECT;
    },
  });

  const node = walker.nextNode();
  if (!node) return false;

  const range = document.createRange();
  const index = node.nodeValue.indexOf(text);

  range.setStart(node, index);
  range.setEnd(node, index + text.length);

  const textRect = range.getBoundingClientRect();
  const containerRect = container.getBoundingClientRect();

  container.scrollTo({
    top: container.scrollTop + textRect.top - containerRect.top - container.clientHeight / 2,
    behavior: "smooth",
  });

  range.detach?.();

  return true;
}
